<template>
  <div class="rate-line">
    <div class="rate-line-cell">
      <span>{{lineData.tmod}}</span>
    </div>
    <div class="rate-line-cell">
      <span>{{lineData.tlib_mod}}</span>
    </div>
    <div class="rate-line-cell">
      <span>{{lineData.ttail}}</span>
    </div>
    <div class="rate-line-cell">
      <span>{{lineData.tlib_opt}}</span>
    </div>
    <div class="rate-line-cell">
      <span>{{lineData.topt}}</span>
    </div>
    <div class="rate-line-cell">
      <span>{{lineData.tcol}}</span>
    </div>
    <div class="rate-line-cell">
      <span>{{lineData.temploi}}</span>
    </div>
    <div class="rate-line-cell">
      <span>{{lineData.ttranche}}</span>
    </div>
    <div class="rate-line-cell">
      <span>{{lineData.tprix}} {{lineData.tcdev}}</span>
    </div>
    <div class="rate-line-cell">
      <span>{{lineData.tcunitp}}</span>
    </div>
  </div>
</template>

<script>
export default {
  props: ["dataline", "index"],
  name: "RateLine",
  data() {
    return {
      lineData: {
        tmod: this.$props.dataline.TMOD,
        tlib_mod: this.$props.dataline.TLIB_MOD,
        ttail: this.$props.dataline.TTAIL,
        tlib: this.$props.dataline.TLIB,
        tlib_opt: this.$props.dataline.TLIB_OPT,
        topt: this.$props.dataline.TOPT,
        tcol: this.$props.dataline.TCOL,
        temploi: this.$props.dataline.TEMPLOI,
        ttranche: this.$props.dataline.TTRANCHE,
        tprix: this.$props.dataline.TPRIX,
        tcunitp: this.$props.dataline.TCUNITP,
        tcdev: this.$store.getters["application/get_application_customer"].TCDEV
      }
    };
  }
};
</script>

<style scoped>
.rate-line {
  display: flex;
  border: solid 1px #e9e9e9;
  margin-top: 10px;
  transition: all 0.3s;
}
.rate-line-cell {
  display: flex;
  width: calc(100% / 10);
  justify-content: center;
  padding: 25px 0px;
}
.rate-line-cell span {
  color: #585858;
  font-size: var(--fz-md);
  transition: all 0.3s;
}
.rate-line:hover {
  background-color: #f5f5f5;
  cursor: pointer;
}
.rate-line:hover .rate-line-cell span {
  color: #8b8b8b;
}
</style>